export const DEPTH = {
  ITEM_DROP: 5,
  CARD: 10,
  CARD_EFFECT: 15,
  HEALTHBAR: 15,
  IMPACT: 20,
  PROJECTILE: 22,
  DAMAGE_NUMBER: 25,
  COMBO: 27,
  OWN_EFFECT: 25,
  MINIGAME_BACKGROUND: 30,
  MINIGAME: 35,
  ITEM_DROP_INFO: 40,
  RESPAWN_BACKGROUND: 45,
  RESPAWN: 50,
};
